import { render, staticRenderFns } from "./LandingPageIndicators.vue?vue&type=template&id=31743fa6&scoped=true"
import script from "./LandingPageIndicators.vue?vue&type=script&lang=js"
export * from "./LandingPageIndicators.vue?vue&type=script&lang=js"
import style0 from "./LandingPageIndicators.vue?vue&type=style&index=0&id=31743fa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31743fa6",
  null
  
)

export default component.exports